export const CASELOAD_TABS = ['all', 'clients', 'contacts', 'referral-requests', 'transfers'] as const;
export type CaseloadTab = (typeof CASELOAD_TABS)[number];

export function resolveCaseloadActiveTab(
  tabParam: string | null,
  visibility: { allTab: boolean; referralRequests: boolean; transferPortal: boolean },
): CaseloadTab {
  if (tabParam === 'all' && !visibility.allTab) return 'clients';
  if (tabParam === 'referral-requests' && !visibility.referralRequests) return 'clients';
  if (tabParam === 'transfers' && !visibility.transferPortal) return 'clients';
  if (tabParam && (CASELOAD_TABS as readonly string[]).includes(tabParam)) {
    return tabParam as CaseloadTab;
  }
  return 'clients';
}
